"use client";

import classNames from "classnames";
import { useTheme } from "next-themes";
import { Toaster as Sonner } from "sonner";

interface ToasterProps extends React.ComponentProps<typeof Sonner> {
  className?: string;
}

const Toaster = ({ className, ...props }: ToasterProps) => {
  const { theme = "light" } = useTheme();

  return (
    <Sonner
      theme={theme as ToasterProps["theme"]}
      className={classNames("toaster group", className)}
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:text-base group-[.toaster]:font-bold group-[.toaster]:bg-white group-[.toaster]:text-font group-[.toaster]:border-stone-300 group-[.toaster]:shadow-lg",
          description: "group-[.toast]:text-font",
          actionButton: "group-[.toast]:bg-main group-[.toast]:text-font",
          cancelButton: "group-[.toast]:bg-stone-500 group-[.toast]:text-white",
        },
      }}
      {...props}
    />
  );
};

export { Toaster };
